import React from 'react';

const escape = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Surligne les occurrences de `query` (insensible à la casse) dans `text`.
 * `radius` (facultatif) : texte long tronqué à l'affichage (ex. release notes) —
 * on montre alors l'extrait AUTOUR de la première occurrence (« …contexte MATCH
 * contexte… ») au lieu du début, sinon le terme trouvé reste invisible.
 */
export default function Highlight({ text, query, radius }) {
  if (text == null || text === '') return null;
  const value = String(text);
  const q = (query || '').trim();
  if (!q) return value;

  let shown = value;
  if (radius) {
    const at = value.toLowerCase().indexOf(q.toLowerCase());
    if (at > radius) {
      const end = Math.min(value.length, at + q.length + radius);
      shown = '…' + value.slice(at - radius, end) + (end < value.length ? '…' : '');
    }
  }
  const parts = shown.split(new RegExp(`(${escape(q)})`, 'ig'));
  return parts.map((part, i) =>
    i % 2 === 1 ? <mark key={i} style={styles.mark}>{part}</mark> : part);
}

/** Vrai si `query` apparaît dans `text` (pour signaler où la recherche a trouvé). */
export const matches = (text, query) =>
  !!query && !!text && String(text).toLowerCase().includes(query.trim().toLowerCase());

const styles = {
  // Couleur de texte fixe : lisible aussi dans les pastilles foncées (version)
  mark: { background: '#ffe58a', color: '#232853', borderRadius: '3px', padding: '0 2px', fontWeight: 600 },
};
